module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product && (_vm.product.needVerifyAddress && !_vm.product.monthSend)) ? _c('div', {
    staticClass: "product-address"
  }, [_c('div', {
    staticClass: "address-input",
    on: {
      "click": _vm.changAddress
    }
  }, [_c('div', {
    staticClass: "addr-text",
    class: {
      empty: !_vm.product._address
    }
  }, [_vm._v(_vm._s(_vm.product._address ? _vm.product._address : '请选择配送区域'))]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.product.unavailable) ? _c('div', {
    staticClass: "unavailable"
  }, [_vm._v("\n      当前位置不支持配送，请选择地址\n    ")]) : (_vm.product._address) ? _c('div', {
    staticClass: "available"
  }, [_vm._v("\n      支持配送\n    ")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "arrow"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4c468c2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/select-address.vue
// module id = 1023
// module chunks = 2